import { render, staticRenderFns } from "./ShiftieLogoAnimated.vue?vue&type=template&id=5ec0636b&scoped=true&"
import script from "./ShiftieLogoAnimated.vue?vue&type=script&lang=js&"
export * from "./ShiftieLogoAnimated.vue?vue&type=script&lang=js&"
import style0 from "./ShiftieLogoAnimated.vue?vue&type=style&index=0&id=5ec0636b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec0636b",
  null
  
)

export default component.exports